'use client'

import { useQuery } from '@tanstack/react-query'

import axios from '@/_lib/axiosInstance'
import { ApiResponse, IAmbulanceCategory } from '@/_types'

/**
 * Loads all ambulance categories for filters and step-1 grouping in the order flow.
 */
export const fetchAmbulanceCategories = async (): Promise<ApiResponse<IAmbulanceCategory[]>> => {
	return axios
		.get<ApiResponse<IAmbulanceCategory[]>>(`v1/web/clinic/ambulance-categories`)
		.then(res => res.data)
}

/**
 * React Query hook for {@link fetchAmbulanceCategories} with a stable `['ambulance-categories']` key.
 */
export const useGetAmbulanceCategories = () => {
	return useQuery<ApiResponse<IAmbulanceCategory[]>>({
		queryKey: ['ambulance-categories'],
		queryFn: () => fetchAmbulanceCategories(),
		select: data => data
	})
}
